import { useEffect } from "react";
import { motion } from "motion/react";
import { Button, Heading, Text } from "@/components/ds";
import { springSnappy } from "@/components/ds/motion";
import { CheckCircleIcon } from "@/icons/CheckCircleIcon";
import styles from "./OnboardingStep.module.css";

interface OnboardingCompleteProps {
  readonly onDone: () => void;
}

export function OnboardingComplete({ onDone }: OnboardingCompleteProps) {
  useEffect(() => {
    const timer = setTimeout(onDone, 1500);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className={styles.complete}>
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={springSnappy}
      >
        <CheckCircleIcon width={64} height={64} className={styles.checkCircle} />
      </motion.div>
      <div>
        <Heading level={1} size="h3">You're all set!</Heading>
        <Text size="sm" color="muted">Your dashboard is ready.</Text>
      </div>
      <Button onClick={onDone}>Go to dashboard</Button>
    </div>
  );
}
